import React from "react";

import { LibraryDetail } from "components/Library/LibraryDetail";

const LibraryDetailPage = () => {
  return <LibraryDetail />;
};
export default LibraryDetailPage;
